import type { GroupsType } from 'hooks/permission/types';

import type { REQUEST_METHODS } from './constants';

export interface AuditLogRecord {
    after: DiffType;
    before: DiffType;
    email: string;
    entity_id: number;
    feature: string;
    id: number;
    method: REQUEST_METHODS;
    project_id: number;
    roles: GroupsType | null;
    timestamp: string;
}

export enum FeaturesTypes {
    branches = 'branches',
    links = 'links',
    screens = 'screens',
    templates = 'templates',
    localization = 'localization',
    themes = 'themes',
    flow = 'flow',
    productCodes = 'product-codes',
    promoCodes = 'campaign',
    products = 'products',
    projects = 'projects',
    users = 'users',
    microTrends = 'micro-trends',
}

export interface AuditLogListResponse {
    items: AuditLogRecord[];
    _meta: {
        page: number;
        per_page: number;
        total_pages: number;
        total_items: number;
    };
}

export type DiffType = Record<string, unknown>;

export interface RequestedParam {
    name: string;
    id: string;
}

export interface LinkGenerationOptionsType {
    type: FeaturesTypes;
    id?: number;
}

export interface FeatureConfig {
    getIdValue: (row: AuditLogRecord, value: number) => number;
    getHref: (idValue: number, type: FeaturesTypes) => string | undefined;
    getTooltipText: (href: string | undefined) => string;
}

export type LinkMapType = Record<string, (id?: number) => string | undefined>;
